var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('span',[_vm._v("Supervisor Contrato")])])
}
var staticRenderFns = []

export { render, staticRenderFns }